import { LinearProgress } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import BookListResults from '../components/book/BookListResults';
import TableNavigationSearch from '../components/book/TableNavigationSearch';
import Content from '../components/Content';
import { observer } from 'mobx-react';

const BooksList = observer(({ bookStore, userStore }) => {
  const navigate = useNavigate();
  const [loadingBooks, setLoadingBooks] = useState(true);

  useEffect(() => {
    if (!userStore.isLoggedIn) {
      navigate('/', { replace: true });
      return;
    }

    bookStore.load().then(() => setLoadingBooks(false));
  }, []);

  return (
    <Content title="Livros-Filhos" userStore={userStore}>
      <>
        <TableNavigationSearch
          loading={ loadingBooks || bookStore.isLoading }
          bookStore={ bookStore }
          userStore={ userStore }
        />
        <br />
        {loadingBooks || bookStore.isLoading ? <LinearProgress /> : <BookListResults bookStore={bookStore} userStore={userStore} />}
      </>
    </Content>
  );
});

BooksList.propTypes = {
  bookStore: PropTypes.object,
  userStore: PropTypes.object,
};

export default BooksList;
